import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, EditableImage } from '../../components';
import { getIcon } from '../iconMap';

function CurriculumHighlights({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  return (
    <section className="py-24 bg-white">
      <div className="container-page grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <span className="eyebrow"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
          <p className="section-lead">
            <EditableText value={data.lead} onChange={(t) => update({ lead: t })} as="span" multiline />
          </p>
          <div className="mt-8 space-y-4">
            {items.map((h, i) => {
              const I = getIcon(h.icon);
              return (
                <div key={i} className="flex gap-4 p-5 rounded-2xl bg-olive-light/60">
                  <div className="h-12 w-12 rounded-xl bg-olive text-white flex items-center justify-center shrink-0"><I size={22} /></div>
                  <div>
                    <EditableText value={h.title} onChange={(t) => updateItem(i, { title: t })} as="h4" className="font-semibold text-olive-deep" />
                    <EditableText value={h.detail} onChange={(t) => updateItem(i, { detail: t })} as="p" multiline className="text-sm text-ink/70 mt-1 leading-relaxed" />
                  </div>
                </div>
              );
            })}
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <EditableImage
            src={data.image?.src}
            alt={data.image?.alt || 'Classroom'}
            onChange={(src, alt) => update({ image: { src, alt } })}
            className="rounded-3xl shadow-soft h-[600px] w-full object-cover"
          />
        </Reveal>
      </div>
    </section>
  );
}

export default CurriculumHighlights;
